export default __webpack_public_path__ + "static/media/regular_van_filled.276d12f7.svg";